const existingEnquiryTemplate = `
<div class="ui-notification">
  <h3>{{header}}</h3>
  <div class="message">
    {{msgBody}}
    
    <br />
    <a class="btn btn-success" ng-click="enquiryAcceptedByUser(enquiryId, senderId)">Accept</a>
    <a class="btn btn-warning" ng-click="enquiryHeldByUser(enquiryId, senderId)">Hold</a>
    <a class="btn btn-danger" ng-click="enquiryRejectedByUser(enquiryId, senderId)">Reject</a>
  </div>
</div>
`;

export default existingEnquiryTemplate;



// WEBPACK FOOTER //
// ./client/app/common/templates/notification/existingEnquiryTemplate.js